import { t } from "i18next";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/store";
import { useMemo } from "react";
import { AnswerTypeEnum } from "../../../types/enum";


interface Props {
    currentIndex: number;
    setCurrentIndex: (index: number) => void;
    onClose:() => void;
}

export default function SurveyQuestionsPreview({ onClose, currentIndex,setCurrentIndex }:Props){

    const questions = useSelector(
        (state: RootState) => state.surveyForm.data.questions
    );
    
    const orderedQuestions = useMemo(
        () => [...questions].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
        [questions]
    );

    const orderedIndex = orderedQuestions.findIndex((item) => item.index === currentIndex);
    const question = orderedIndex >= 0 ? orderedQuestions[orderedIndex] : questions[currentIndex];


    const goPrev = () => {
        if (orderedIndex <= 0) return;
        setCurrentIndex(orderedQuestions[orderedIndex - 1].index);
    };

    const goNext = () => {
        if (orderedIndex < 0 || orderedIndex >= orderedQuestions.length - 1) return;
        setCurrentIndex(orderedQuestions[orderedIndex + 1].index);
    };
 
    const renderAnswer = () => {
        const answerType = Number(question?.answerType) as AnswerTypeEnum;
        
        return (
            <>
                {(answerType === AnswerTypeEnum.NPS ||
                answerType === AnswerTypeEnum.Text) && (
                    <Form.Control disabled placeholder={t("survey:preview.answerHereText")} className="mt-3" />
                )}
                {answerType === AnswerTypeEnum.Number && (
                <>
                    <Form.Control type="number" disabled placeholder={t("survey:preview.answerHereText")} className="mt-3"/>

                    {(question.minimumValue != null || question.maximumValue != null) && (
                    <div className="text-muted mt-1" style={{ fontSize: "0.85rem" }}>
                        {question.minimumValue != null && (
                            <span>{t("survey:preview.scoreText")} {question.minimumValue}</span>
                        )}
                    
                        {question.maximumValue != null && (
                            <span> {t("survey:preview.toText")} {question.maximumValue}</span>
                        )}
                    </div>
                    )}
                </>
                )}

                {answerType === AnswerTypeEnum.Option && (
                <div className="mt-3">
                    {question.answerOptions?.map((opt, index) => (
                    <Form.Check
                        key={index}
                        type={question.isMultiselector ? "checkbox" : "radio"}
                        label={opt.text?.catalan}
                        disabled
                        className="mb-2"
                    />
                    ))}
                </div>
                )}
            </>
        )
    };
      
    return (
        <div className="survey-preview d-flex flex-column h-100" style={{ position: 'relative', paddingBottom: '80px' }}>
            <Row className="mb-4">
                <Col className="d-flex justify-content-end">
                    <Button onClick={onClose}>{t("survey:preview.returnButton")}</Button>
                </Col>
            </Row>
            
            <Row className="question-list-item-container ml-3 mr-1 px-3 py-2">
                <Col>
                    {(orderedIndex >= 0 ? orderedIndex + 1 : currentIndex + 1)}{". "}{question?.text?.catalan}
                </Col>
            </Row>

            <Row className="ml-1 px-3 py-2">
                {renderAnswer()}
            </Row>

            <Row className="justify-content-end gap-4 mb-4" style={{ 
                position: 'absolute', 
                bottom: 0, 
                left: 0, 
                right: 0 }}>
                <Col xs="auto">
                    <Button
                        variant="light"
                        className="survey-nav-btn prev-btn"
                        onClick={goPrev}
                        disabled={orderedIndex <= 0}
                    >
                        {t("survey:preview.previous")}
                    </Button>
                </Col>

                <Col xs="auto">
                    <Button
                        className="survey-nav-btn next-btn"
                        onClick={goNext}
                        disabled={orderedIndex < 0 || orderedIndex === orderedQuestions.length - 1}
                    >
                        {t("survey:preview.next")}
                    </Button>
                </Col>
            </Row>
        </div>
    );
}